import axios, { AxiosRequestConfig } from 'axios';

import ENVIRONMENT from '@/environments/environment';

// eslint-disable-next-line import/no-cycle
import { setupInterceptorsTo } from '../api/Interceptors';

const CONTENT_TYPE = 'application/json';

export const axiosInstance = setupInterceptorsTo(
  axios.create({
    baseURL: ENVIRONMENT.BASE_URL,
    headers: {
      'Content-Type': CONTENT_TYPE,
    },
  }),
);

const Api = {
  GET: async (URL: string, config?: AxiosRequestConfig): Promise<any> => {
    const request = await axiosInstance.get(URL, config);
    return request;
  },
  POST: async (URL: string, data?: object, config?: AxiosRequestConfig): Promise<any> => {
    const request = await axiosInstance.post(URL, data, config);
    return request;
  },
  PUT: async (URL: string, data: object): Promise<any> => {
    const request = await axiosInstance.put(URL, data);
    return request.data;
  },
  PATCH: async (URL: string, data: object): Promise<any> => {
    const request = await axiosInstance.patch(URL, data);
    return request.data;
  },
  DELETE: async (URL: string): Promise<any> => {
    const request = await axiosInstance.delete(URL);
    return request.data;
  },
};

export default Api;
